import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { FacultyView } from '@/module/Faculty/FacultyView';
import { getFacultyOptions } from '@/module/Faculty/model/FacultyQuery';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { facultyId } = Route.useParams();
  const { data: faculty } = useSuspenseQuery(getFacultyOptions(facultyId));

  return <FacultyView faculty={faculty} />;
}
